/**
 * Sources / Default / Components / Overwrites / Shared > Slider
 *
 * @copyright 2024 i-fabrik GmbH
 * @author Heiko Pfefferkorn
 */

import SelectorEngine from '@ifabnpm/bootstrap/dom/selector-engine.js';

import Slider from '@ifabnpm/bootstrap/component/slider.js';

// -------
// Private
// -------

/**
 * Alle verfügbaren Slider (Attribut `data-slider`) initialisieren.
 *
 * @returns {HTMLElement|Array}
 */
const init = () => {
	const collection = SelectorEngine.find(`[data-c="slider"]`, document.documentElement);

	let group = [];

	for (const element of collection) {
		let _o = {
			navigation         : {
				addIcons: false
			},
		};

		if (element.dataset.sliderEffect) {
			if (element.dataset.sliderEffect === 'fade') {
				_o.effect     = 'fade';
				_o.fadeEffect = {
					crossFade: true
				};
			} else {
				// Do nothung
			}
		}

		group.push(Slider.init(element, _o));
	}

	return group;
};

// ------
// Public
// ------

// Export
export default {
	init   : (window.depCheckSlider ? init : noop),
	rebuild: (window.depCheckSlider ? Slider.rebuild : noop)
};
